<div class="form-horizontal">
  <div class="form-group">
    <label class="col-md-1 control-label">Código Solicitud:</label>
    <div class="col-md-1">
      <mat-form-field appearance="outline">
        <mat-label>Código Solicitud:</mat-label>
        <input matInput type="text" disabled="disabled" aria-label="Contratista" name="codigo" [value]="model.codigo" />
      </mat-form-field>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-1 control-label">Compañía:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label> Compañía: </mat-label>
        <input matInput type="text" [(ngModel)]="model.compania" disabled />
      </mat-form-field>
    </div>
    <label class="col-md-1 control-label">Sede:</label>
    <div class="col-md-2">
      <mat-form-field appearance="outline">
        <input matInput type="text" [(ngModel)]="model.nombreSede" disabled />
      </mat-form-field>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-1 control-label">Empresa:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Empresa:</mat-label>
        <input matInput type="text" [(ngModel)]="model.contratista" disabled />
      </mat-form-field>
    </div>
    <label class="col-md-1 control-label">Fecha Inicio (*):</label>
    <div class="col-md-2">
      <!-- <mat-form-field appearance="outline">
                <input matInput type="date" [(ngModel)]="itemSolicitud.fechaInicio" placeholder="dd/MM/yyyy" name="fechaInicio"/>
              </mat-form-field>   
            #fechaInicio="ngModel"
            #fechaFin="ngModel" -->
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-label>Fecha Inicio</mat-label>
        <input matInput [matDatepicker]="pckrFechaInicio" [(ngModel)]="model.fechaInicio" [disabled]="disabled"
          id="fechaInicio" name="fechaInicio" [max]='model.fechaFin' required />
        <mat-datepicker-toggle matSuffix [for]="pckrFechaInicio"></mat-datepicker-toggle>
        <mat-datepicker #pckrFechaInicio></mat-datepicker>
        <!-- <mat-error *ngIf="fechaInicio.invalid">Requerido</mat-error> -->
      </mat-form-field>
    </div>
    <label class="col-md-1 control-label">Fecha Fin (*):</label>
    <div class="col-md-2">
      <!-- <mat-form-field appearance="outline">
                <input matInput type="date" [(ngModel)]="itemSolicitud.fechaFin" placeholder="dd/MM/yyyy" name="fechaFin"/>
              </mat-form-field>    -->
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-label>Fecha Fin</mat-label>
        <input matInput [matDatepicker]="pckrFechaFin" [(ngModel)]="model.fechaFin" [disabled]="disabled"
          name="fechaFin" [min]='model.fechaInicio' required />
        <mat-datepicker-toggle matSuffix [for]="pckrFechaFin"></mat-datepicker-toggle>
        <mat-datepicker #pckrFechaFin></mat-datepicker>
        <!-- <mat-error *ngIf="fechaFin.invalid">Requerido</mat-error> -->
      </mat-form-field>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-1 control-label">OC:</label>
    <div class="col-md-2">
      <mat-form-field appearance="outline">
        <mat-label>Orden de compra</mat-label>
        <input matInput type="text" [(ngModel)]="model.ordenCompra" name="ordenCompra" [disabled]="disabled" />
      </mat-form-field>
    </div>
    <label class="col-md-1 col-md-offset-2 control-label">Notificar a:</label>
    <div class="col-md-3">
      <mat-form-field appearance="outline">
        <mat-label>Notificar a</mat-label>
        <input matInput type="text" [(ngModel)]="model.notificarA" name="notificarA" [disabled]="disabled" />
      </mat-form-field>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-1 control-label">Trabajo (*):</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Trabajo</mat-label>
        <input matInput type="text" [(ngModel)]="model.trabajo" name="trabajo" required [disabled]="disabled" />
      </mat-form-field>
    </div>
    <label class="col-md-1 control-label">Subcontratista:</label>
    <div class="col-md-5">
      <mat-form-field appearance="outline">
        <mat-label>Subcontratista</mat-label>
        <input matInput type="text" [(ngModel)]="model.subContratista" name="subContratista" [disabled]="disabled" maxlength="100" />
      </mat-form-field>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-1 control-label">Motivo (*):</label>
    <div class="col-md-10">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Motivo</mat-label>
        <textarea matInput placeholder="Motivo" [(ngModel)]="model.motivo" rows="5" name="motivo" [maxlength]="2000"
          required [disabled]="disabled"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-1 control-label">Tipo de visita:</label>
    <div class="col-md-2">
      <mat-form-field appearance="outline">
        <input matInput type="text" [(ngModel)]="model.tipoVisita" disabled />
      </mat-form-field>
    </div>
    <label class="col-md-2 control-label">Responsable Engie (*):</label>
    <div class="col-md-2">
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-label>
          Seleccione
        </mat-label>
        <mat-select matSelect [(ngModel)]="model.solicitadoPor" name="solicitadoPor"
          [disabled]="!model.puedeCambiarSolicitante">
          <mat-option *ngFor="let item of listaSolicitantes; index as i;" [value]='item.codigoUsuario'>{{ item.nombres +
            ' ' + item.apellidos}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>